import React, { useReducer, useEffect } from 'react';
import axios from 'axios';
import SettingsContext from './settingsContext';

const initialState = {
    settings: {
        site_name: 'QRezervasyon',
        site_title: 'QRezervasyon - Dijital Menü ve Rezervasyon Platformu',
        site_description: '',
        site_keywords: '',
        primary_color: '#ee6c2b',
        currency: 'TRY',
        maintenance_mode: false
    },
    loading: true
};

const settingsReducer = (state, action) => {
    switch (action.type) {
        case 'GET_SETTINGS':
            return {
                ...state,
                settings: action.payload,
                loading: false
            };
        case 'SETTINGS_ERROR':
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};

const SettingsState = props => {
    const [state, dispatch] = useReducer(settingsReducer, initialState);

    // Get Settings
    const getSettings = async () => {
        try {
            const res = await axios.get('/api/public/settings');
            dispatch({
                type: 'GET_SETTINGS',
                payload: res.data
            });

            // Apply dynamic styles if primary_color exists
            if (res.data.primary_color) {
                document.documentElement.style.setProperty('--primary-color', res.data.primary_color);
            }
            
            // Set dynamic SEO tags
            if (res.data.site_title) document.title = res.data.site_title;
            
        } catch (err) {
            dispatch({ type: 'SETTINGS_ERROR' });
        }
    };

    useEffect(() => {
        getSettings();
    }, []);

    return (
        <SettingsContext.Provider
            value={{
                settings: state.settings,
                loading: state.loading,
                getSettings
            }}
        >
            {props.children}
        </SettingsContext.Provider>
    );
};

export default SettingsState;
